module.exports = __webpack_public_path__ + "img/visitors_center.25282439.jpg";